<template>
  <div>
    <div class="mobile-header">
      <img src="../../../static/images/closePerson.png" class="closePerson" @click="cannelGoBack()" alt />
      <h3>个人设置</h3>
    </div>
    <div class="perSet_he">
      <form>
        <van-field
          v-model="form.mobile"
          placeholder="请输入手机号"
          label="手机号"
          type="text"
          name="mobile"
          required
          clearable
          label-align="left"
        />
        <!-- v-validate="'required|length:1,11'"
        :error-message="errors.first('mobile')"-->
        <van-field v-model="form.name" type="text" required label="姓名" placeholder="请输入姓名" />
        <van-field
          required
          readonly
          clickable
          label="出生日期"
          v-model="form.birthday"
          placeholder="选择出生日期"
          right-icon="arrow-down"
          @click="showBirthdayPicker = true"
        />
        <van-popup v-model="showBirthdayPicker" position="bottom">
          <van-datetime-picker
            type="date"
            @cancel="showBirthdayPicker = false"
            :min-date="minDate"
            :max-date="maxDate"
            default-date
            @confirm="onBirthdayConfirm"
          />
        </van-popup>
        <!-- 证件照 -->
        <div class="sexDiv">
          <span class="sexTitle fl">
            <i>*</i>证件照
          </span>
          <span class="imgDes">仅支持jpg/png格式文件,大小须不超过5M</span>
          <van-uploader :after-read="onRead2" class="upImg">
              <img :src="form.picture" v-if="form.picture" class="PersonImg" alt />
            <van-icon class="plusPicture"  name="plus" v-else></van-icon>
          </van-uploader>
        </div>
        <!-- 选择省市区 -->
        <van-field
          readonly
          clickable
          required
          label="所在城市"
          :value="areavalue"
          ref="accountTypePopup2"
          placeholder="选择所在城市"
          @click="showPicker = true"
          right-icon="arrow-down"
        />
        <van-popup v-model="showPicker" ref="accountTypePopup" position="bottom">
          <van-picker
            show-toolbar
            title="请选择地区"
            value-key="positionName"
            :columns="areaList"
            @change="onAreaChange"
            @cancel="onCancel"
            @confirm="onAreaConfirm"
          />
        </van-popup>
        <!-- 性别 -->
        <div class="sexDiv">
          <span class="sexTitle">
            <i>*</i>性别
          </span>
          <van-radio-group  v-model="form.sex" style="display:flex;flex-direction:row"  >
            <van-radio name="0" class="correct">男</van-radio>
            <van-radio name="1">女</van-radio>
          </van-radio-group>
        </div>
        <!--身份证号  -->
        <van-field
          v-model="form.IdCard"
          label="身份证号"
          required
          clickable
          placeholder="请输入身份证号"
          clearable
        />
        <!--职业  -->
        <van-field v-model="form.job" label="职业" required clickable placeholder="请输入职业" clearable />
        <!--工作单位  -->
        <van-field v-model="form.department" label="工作单位"  clickable placeholder="请输入工作单位" clearable />
        <!-- 绑定手机号 -->
        <div class="bd_he">
          <van-field
            v-model="form.mobile"
            center
            clearable
            label="绑定手机号"
            placeholder="请输入绑定的手机号"
            class="budgeMobileInput"
          ></van-field>
          <span class="budgeCell senMsg" @click="budgeMobile">去修改或绑定</span>
        </div>
        <!-- 去绑定手机号 -->
        <van-dialog v-model="budgeMobileShow" title="修改绑定手机号" :showConfirmButton="false">
          <van-field v-model="form.mobile" center clearable label="手机号" placeholder="请输入绑定的手机号"></van-field>
          <div class="bd_he">
            <van-field
              v-model="yzm"
              center
              clearable
              label="验证码"
              placeholder="请输入验证码"
              class="budgeMobileInput budgeMobileDia"
            ></van-field>
            <span
              class="budgeCell senMsg"
              @click="sendMessage"
              :disabled="sendCodeBtnDisabled"
            >{{sendCodeCaption}}</span>
          </div>
           <div class="applyInvoiceHint">
          <button @click="cancelBillSave" >确定</button>
          <button @click="budgeMobileShow = false">取消</button>
           </div>
        </van-dialog>
        <!-- <div class="mobileLoginBtn_he personalBtn">
          <van-button
            class="LoginBtn_he"
            native-type="button"
            :disabled="loginDisable"
            :loading="loadingFlg"
            loading-text="加载中..."
            type="primary"
            @click="personalSet()"
          >保存</van-button>
        </div> -->
         <div class="mobileLoginBtn_he"   @click="personalSet()">
            <img src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/mobileSuccess750.png" width="100%" alt="登录文字" />
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      minDate: new Date(1929, 1, 1),
      maxDate: new Date(2019, 8, 1),
      yzm: "",
      areaList: [{ values: [] }, { values: [] }, { values: [] }],
      radio: [],
      showBirthdayPicker: false,
      budgeMobileShow: false,
      loadingFlg: false,
      loginDisable: false,
      value: "",
      showPicker: false,
      provinceList: [],
      cityList: [],
      blockList: [],
      checked: true,
      type: "updateMobile",
      province: 1,
      sendCodeBtnDisabled: false,
      loadingFlg: false,
      loginDisable: false,
      disabled: false,
      sendCodeCaption: "获取验证码",
      getUserInforList: [], //回显个人信息列表项
      form: {
        name: "",
        mobile: "",
        birthday: "",
        picture: "",
        sex: "",
        IdCard: "",
        job: "",
        mobile: "",
        county: "",
        year: "",
        month: "",
        day: "",
        department:""
      },
      showPicker: false, //遮罩层显示或隐藏
      hallImg: [],
      checkCity: "", //Picker拿到的值
      areavalue: ""
    };
  },
  methods: {
    /**
     * 选择出生日期确认
     * @param value 选择值
     */
    onBirthdayConfirm(value) {
      this.form.birthday = this.$util.formatDate.formatSimple(value);
      var year = "",
        month = "",
        day = "";
      year = this.form.birthday.substr(0, 4);
      month = this.form.birthday.substr(5, 2);
      day = this.form.birthday.substr(8, 2);
      this.form.year = year;
      this.form.month = month;
      this.form.day = day;
      this.showBirthdayPicker = false;
    },
    /**
     *  省市区初始化
     * */
    getArea(pid, index) {
      //  const options = {ParentId};
      this.$api.get("/user/getAreaChildById", { pId: pid }, res => {
        let province = res;
        this.areaList[index].values = [
          { positionName: "请选择" },
          ...province //ES6新语法
        ];
        if (index < 2) {
          //当请求的是三级内的内容时
          this.areaList[index + 1].values = [];
        }
        this.areaList = [...this.areaList];
      });
    },
    //当地区选择变化时
    onAreaChange(picker, values, index) {
      if (index < 2) {
        this.getArea(values[index].id, index + 1); //传参 参数为上层选择的地区的id;
      }
      this.form.county = values[index].id;
    },

    //点击取消
    onCancel() {
      this.showPicker = false;
    },

    //点击确定
    onAreaConfirm(val) {
      this.areavalue =
        val[0].positionName +
        "," +
        val[1].positionName +
        "," +
        val[2].positionName;
      this.showPicker = false;
    },
    // ...
    // 修改 columns 方法
    changeColumns(provinceId, cityId) {
      // 根据id得到下标
      this.areaList[0].values.forEach(element => {
        if (element.id == provinceId) {
          this.areavalue = element.positionName;
        }
      });
    },

    budgeMobile() {
      this.budgeMobileShow = true;
    },
    isExistMobile() {
      let param = {};
      param.type = this.type;
      param.mobile = this.form.mobile;
      this.$api.get("/user/isExistMobile", param, res => {
        if (res.status == 1) {
          Toast(res.message);
          return false;
        } else {
          let param = {};
          param.type = this.type;
          param.mobile = this.form.mobile;
          this.$api.get("/user/sendyanzheng", param, res => {
            if (res.status == 0) {
              Toast("已发送到您的手机");
              this.countDown();
            } else {
              Toast(res.message);
            }
          });
        }
      });
    },
    // 发送验证码
    sendMessage() {
      // 先判断手机号是否为空 为空输入手机号
      if (this.form.mobile == "") {
        Toast("请输入手机号");
        return false;
      } else if (!this.$util.isPhoneNumber(this.form.mobile)) {
        Toast("请输入正确的手机号");
        return false;
      }
      this.isExistMobile();
    },
    // 检查验证码是否正确
    yzmRight() {
      if (this.yzm == "") {
        return false;
      }
      let param = {};
      param.type = this.type;
      param.code = this.yzm;
      this.$axiosPackag.getMessageByAxios(
        "GET",
        "/user/validCode",
        param,
        null,
        null,
        resD => {
          Toast("绑定成功");
          this.budgeMobileShow = false;
        },
        errorCall => {}
      );
    },
    countDown() {
      var i = 300;
      this.sendCodeBtnDisabled = true;
      this.refreshTimer = setInterval(() => {
        this.sendCodeCaption = i + "秒后可重新发送";
        i = i - 1;
        if (i == 0) {
          this.clearCountDown();
        }
      }, 1000);
    },
    clearCountDown() {
      this.sendCodeBtnDisabled = false;
      this.sendCodeCaption = "获取验证码";
      clearInterval(this.refreshTimer);
    },

    /**
     * 更改手机号
     */
    cancelBillSave() {
      if (this.yzm == "") {
        Toast("请输入验证码");
        return false;
      }else{
         this.yzmRight();
      }
      
    },
    // 上传图像
    onRead2(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append("file", content);
      formData.append("uploadType", "image");
      formData.append("size", file.file.size);
      this.$api.formpost("/FileUpload/upload", formData, res => {
        if ((res.status = "success")) {
          this.form.picture = res.showAddress;
        }
      });
    },

    /**
     * 获取个人信息
     */
    judgeLogin() {
      if (localStorage.getItem("loginUrl")) {
        this.getUserInfor();
      } else {
        Toast("请先登录");
        this.$router.push({ path: "/mobileLogin" });
      }
    },
    getUserInfor() {
      this.$api.get("/user/getUserDetail", null, res => {
        if (status == 0) {
          this.form.name = res.data.realName;
          this.form.mobile = res.data.mobile;
            this.form.county=res.data.county;
          this.form.job = res.data.jobId;
          this.form.department = res.data.department;
          this.form.picture = res.data.picture;
          this.form.IdCard = res.data.idcard;
          this.form.sex = res.data.sex=='M'?'0':'1';
          this.form.birthday = this.$util.formatDate.formatSimple(
            res.data.birthday
          );
          if(res.data.provinceName){
              this.areavalue+= res.data.provinceName+",";
          }
          if(res.data.cityName){
              this.areavalue+= res.data.cityName+",";
          }
          if(res.data.countyName){
              this.areavalue+= res.data.countyName+",";
          }
          if(!this.$util.isBlackStr(this.areavalue)&&this.areavalue.length>0){
              this.areavalue=this.areavalue.substring(0,this.areavalue.length-1);

          }
//          this.areavalue =res.data.provinceName +"," +res.data.cityName +"," +res.data.countyName;
       var year = "",
        month = "",
        day = "";
      year = this.form.birthday.substr(0, 4);
      month = this.form.birthday.substr(5, 2);
      day = this.form.birthday.substr(8, 2);
      this.form.year = year;
      this.form.month = month;
      this.form.day = day;
          this.changeColumns(this.province, this.city);
        }
      });
    },
    // 保存
    personalSet() {
      let params = {};
      params.realName = this.form.name;
      params.idcard = this.form.IdCard;
      params.sex = this.form.sex==0?'M':'F' ;
      params.job = this.form.job;
      params.county = this.form.county;
      params.picture = this.form.picture;
      params.year1 = this.form.year;
      params.month1 = this.form.month;
      params.day1 = this.form.day;
      params.department = this.form.department;
        if (this.$util.isBlackStr(this.form.name)) {
            Toast("请输入姓名");
            return false;
        }
        if (this.$util.isBlackStr(this.form.IdCard)) {
            Toast("请输入身份证号");
            return false;
        }
        if (this.$util.isBlackStr(this.form.sex)) {
            Toast("请输入性别");
            return false;
        }
        if (this.$util.isBlackStr(this.form.job)) {
            Toast("请输入职位");
            return false;
        }
        if (this.$util.isBlackStr(this.form.county)) {
            Toast("请选择所在城市");
            return false;
        }
        if (this.$util.isBlackStr(this.form.picture)) {
            Toast("请上传头像");
            return false;
        }
        if (this.$util.isBlackStr(this.form.year)||this.$util.isBlackStr(this.form.month)||this.$util.isBlackStr(this.form.day)) {
            Toast("请选择出生日期");
            return false;
        }
        this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null,
            params, null, resD => {
                    this.$router.push({ path: "/mobileStudy" });
            });

    },
     cannelGoBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getArea(1, 0);
    this.judgeLogin();
  }
};
</script>

<style scoped>
.closePerson {
  position: absolute;
  height: 0.4rem;
  height: 0.4rem;
  left: 0.4rem;
  top: 0.4rem;
}
.mobile-header h3 {
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: 0.426667rem;
  font-weight: bold;
  line-height: 0.8rem;
}
.correct {
  margin-right: 20px;
}
.sexDiv {
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  border-bottom: 1px solid #ebedf0;
  margin-left: 8px;
}
.sexTitle {
  width: 90px;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  margin-right: 10px;
}
.sexTitle i {
  color: #ee0a24;
  font-size: 14px;
  margin-right: 5px;
}
.van-cell {
  margin-bottom: 0.3rem;
}
.personalBtn {
  margin: 0.893333rem;
}
.picTips {
  color: #000;
  font-size: 0.02rem;
}
.PersonImg {
  width: 1.2rem;
  height: 1.2rem;
}
.plusPicture{
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  border:1px dotted #666
}
.imgDes {
  float: left;
  width: 5.4rem;
  height: 1.186667rem;
}
.budgeMobileInput {
  width: 6.933333rem;
}
.senMsg {
  display: inline-block;
  padding: 5px 10px;
  margin: 5px 0;
  color: #ffffff;
  border-radius: 8px;
  font-size: 12px;
  position: absolute;
  right: 0.32rem;
  top: 0.08rem;
}
.bd_he {
  position: relative;
}
.budgeMobileDia {
  width: 5.093333rem;
}
.applyInvoiceHint {
  text-align: center;
  padding: 0.54rem 1.21rem 0.7rem;
  font-size: 0.26rem;
  line-height: 0.4rem;
  color: #999;
}
.applyInvoiceHint img {
  width: 1.16rem;
  height: 1.15rem;
  margin-bottom: 0.25rem;
}
.applyInvoiceHint p {
  word-wrap: break-word;
}
.applyInvoiceHint button {
  width: 2.45rem;
  height: 0.8rem;
  font-size: 0.32rem;
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  background-color: #16a6f8;
  margin-top: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// MobilePersonal.vue?888ca8a6